import { IAnyObj } from 'constants/types/common.types'

class CheckupParameter {
  parameter: IAnyObj
  constructor() {
    this.parameter = {}
  }
  set(obj: IAnyObj) {
    this.parameter = { ...this.parameter, ...obj }
  }

  get(key: string) {
    return this.parameter[key]
  }

  getAll() {
    return this.parameter
  }
}

export default new CheckupParameter()
